const handleDownload = (fileUrl, fileName) => {
  const link = document.createElement("a");
  link.href = fileUrl;

  // detect file extension
  let extension = "file";
  if (fileUrl.startsWith("data:application/pdf")) {
    extension = "pdf";
  } else if (fileUrl.startsWith("data:image/")) {
    extension = "png";
  } else {
    const parts = fileUrl.split(".");
    extension = parts.length > 1 ? parts.pop() : "file";
  }

  link.download = `${fileName}.${extension}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { handleDownload };
